import type { PlateElementProps } from 'platejs/react';
import { useEditorReadOnly } from 'platejs/react';
import React, { useCallback } from 'react';

export const LinkElement: React.FC<PlateElementProps> = ({
  attributes,
  children,
  element,
}) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- Plate link element url property not typed in base TElement
  const url = (element as any).url || '';
  const readOnly = useEditorReadOnly();

  const handleClick = useCallback(
    (e: React.MouseEvent<HTMLAnchorElement>) => {
      // In edit mode, prevent navigation to allow Plate.js to handle link editing
      if (!readOnly) {
        e.preventDefault();
      }
    },
    [readOnly]
  );

  // In read-only mode, use a proper anchor tag for navigation
  // In edit mode, use anchor but prevent default navigation
  return (
    <a
      {...attributes}
      href={url}
      className='text-blue-600 hover:text-blue-700 underline decoration-blue-300 hover:decoration-blue-500 transition-colors cursor-pointer'
      title={url}
      target={readOnly ? '_blank' : undefined}
      rel={readOnly ? 'noopener noreferrer' : undefined}
      onClick={handleClick}
    >
      {children}
    </a>
  );
};
